'use strict';
// 创建人：bai.zhiming
// 日期：2016-8-24
// 描述：产品管理微信服务
angular
    .module('productManagementWeixinServiceModule', ['wechatModal', 'productManageMentWeixinSubscriptionModifyModule', 'productmanageWechatBindModelModule'])
    .factory('productManagementWeixinService', [
        '$q',
        'trsHttpService',
        '$modal',
        function ($q, trsHttpService, $modal) {
            return {

                /**
                 * [getOperRight description]获取微信渠道操作权限
                 *
                 * @param   {[type]}  id  [id description]
                 *
                 * @return  {[type]}      [return description]
                 */
                getOperRight: function (id) {
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_metadataright',
                        methodname: 'queryOperkeyOfWeChat',
                        Classify: 'wechatset.channel',
                        AccountId: id,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        var right = {};
                        for (var i = 0; i < data.length; i++) {
                            right[data[i].split('.')[2]] = true;
                        }
                        deffer.resolve(right);
                    });
                    return deffer.promise;
                },

                /**
                 * [modifySubscription description] 编辑公众号弹窗
                 * @param  {[type]} success [description]
                 * @return {[type]}         [description]
                 */
                modifySubscription: function (item, success) {
                    var modalInstance = $modal.open({
                        templateUrl: 'manageConfig/productManageMent/weixin/service/modify/subscription_modify_tpl.html',
                        windowClass: 'productManageMent-weixin-subscription-modify',
                        backdrop: false,
                        controller: 'productManageMentWeixinSubscriptionModifyCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    return modalInstance.result.then(function (data) {
                        success(data);
                    });
                },
                wechatModal: function (selected) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: 'manageConfig/productManageMent/weixin/service/wechatModal/wechatModal.html',
                        windowClass: 'wechat_model',
                        backdrop: false,
                        controller: 'wechatModalCtrl',
                        resolve: {
                            selected: function () {
                                return selected;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        defer.resolve(result);
                    });
                    return defer.promise;
                },
                newWechatBindModel: function (url) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: 'manageConfig/productManageMent/weixin/service/wechatBindModel/wechatBindModel.html',
                        windowClass: 'wechat_bind_model',
                        backdrop: false,
                        keyboard: false,
                        controller: 'productmanageWechatBindModelCtrl',
                        resolve: {
                            url: function () {
                                return url;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        defer.resolve(result);
                    }, (info) => {
                        defer.reject(info);
                    });
                    return defer.promise;
                },
            };
        },
    ]);
